import { EventType } from "@azure/msal-browser";

const useMSAL = ({ setIsFetchingMSAL, msalInstance, clientId, tenantId }) => {
  // Construye el scope dinámico para tu API (sin Microsoft Graph)
  const apiScope = [`api://${clientId}/.default`];
  const dynamicLoginRequest = {
    scopes: apiScope,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    // Forzar MFA si es requerido
    extraQueryParameters: {
      // Opcional: forzar re-autenticación con MFA
      // prompt: 'login',
      // amr_values: 'mfa' // Requiere MFA específicamente
    },
  };

  if (msalInstance) {
    msalInstance.addEventCallback((event) => {
      if (
        event.eventType === EventType.LOGIN_SUCCESS &&
        event.payload.account
      ) {
        const account = event.payload.account;
        msalInstance.setActiveAccount(account);
        getTokenPopup();
      }
    });
  }

  const handleLogin = async () => {
    try {
      if (msalInstance) {
        setIsFetchingMSAL(true);

        if (msalInstance.getAllAccounts()[0]) {
          msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
          getTokenPopup();
        } else {
          await msalInstance.loginPopup({
            ...dynamicLoginRequest,
            prompt: "select_account",
          });
        }
      }
    } catch (error) {
      window.location.reload();
    }
  };

  function getTokenPopup() {
    return msalInstance
      .acquireTokenSilent(dynamicLoginRequest)
      .then((response) => {
        const {
          accessToken,
          account: { username },
        } = response;

        const params = new URLSearchParams({
          el: username,
          ac: accessToken,
        });

        window.location.href = `${
          window.location.origin
        }/login?${params.toString()}`;
      })
      .catch((error) => {
        console.log(error);
        console.log(
          "silent token acquisition fails. acquiring token using popup"
        );

        // fallback to interaction when silent call fails
        return msalInstance
          .acquireTokenPopup(dynamicLoginRequest)
          .then((tokenResponse) => {
            const params = new URLSearchParams({
              el: tokenResponse.account.username,
              ac: tokenResponse.accessToken,
            });

            window.location.href = `${
              window.location.origin
            }/login?${params.toString()}`;
            return tokenResponse;
          })
          .catch((error) => {
            console.log(error);
          });
      });
  }

  return { msalInstance, handleLogin };
};

export default useMSAL;
